export default "__VITE_ASSET__8f352eaf__"